import React, { PureComponent } from 'react';
import _ from 'lodash';
import { data } from '../../../data';
import SortingTabs from '../SortingTabs';
import SortingDropdowns from '../SortingDropdowns';
import RankingList from '../RankingList';
import Map from '../Map';
import CityInfo from '../CityInfo';
import CityChart from '../CityChart';
import Footer from '../Footer';
import { YEARS, MAX_COUTRY_LIST_ITEMS, ACTIVE_YEAR } from '../../../helpers';
import './index.scss';
import { getText } from '../../../copies';

type CityWithOrderBy = (typeof data.cities)[0] & { orderBy: number };

interface FreelanceImpactState {
  cities: CityWithOrderBy[];
  sorting: typeof data.sorting;
  activeSorting: {
    year: number;
    speciality: string;
    category: string;
  };
  accentColor: string;
  activeYear: number;
  currentCityInfo: null | CityWithOrderBy;
}

class FreelanceImpact extends PureComponent<any, FreelanceImpactState> {
  constructor(props) {
    super(props);

    this.state = {
      cities: [],
      sorting: data.sorting,
      activeSorting: {
        year: YEARS[YEARS.length - 1],
        speciality: data.sorting.speciality[0].value,
        category: data.sorting.category[0].value,
      },
      accentColor: data.sorting.speciality[0].accentColor,
      currentCityInfo: null,
      activeYear: ACTIVE_YEAR,
    };

    this.sortingChangeHandler = this.sortingChangeHandler.bind(this);
    this.getAccentColor = this.getAccentColor.bind(this);
    this.getSortedCities = this.getSortedCities.bind(this);
    this.showCityView = this.showCityView.bind(this);
    this.hideCityView = this.hideCityView.bind(this);
  }

  override UNSAFE_componentWillMount() {
    const { year, speciality, category } = this.state.activeSorting;

    this.setState({ cities: this.getSortedCities(year, speciality, category) });
  }

  sortingChangeHandler(name, value) {
    const activeSorting = { ...this.state.activeSorting, [name]: value },
      { year, speciality, category } = activeSorting,
      accentColor = this.getAccentColor(name, value) || this.state.accentColor,
      cities = this.getSortedCities(year, speciality, category);

    this.setState({ activeSorting, accentColor, cities, activeYear: year });
  }

  getAccentColor(name, value) {
    let accentColor = '';

    if (name === 'speciality') {
      this.state.sorting.speciality.forEach((speciality) => {
        if (value === speciality.value) {
          accentColor = speciality.accentColor;
        }
      });
    }

    return accentColor;
  }

  getCityYearData(city, year) {
    return city.chart_data.find((data) => parseInt(data.year, 10) === parseInt(year, 10));
  }

  getCityYear(city, year, speciality, category) {
    const yearData = this.getCityYearData(city, year);

    return yearData ? yearData[speciality][category] : null;
  }

  getSortedCities(year, speciality, category): CityWithOrderBy[] {
    const citiesWithOrderBy = data.cities
      .filter((city) => !!this.getCityYearData(city, year))
      .map((city) => ({
        ...city,
        orderBy: this.getCityYear(city, year, speciality, category),
      }))
      .splice(0, MAX_COUTRY_LIST_ITEMS);

    return _.orderBy(citiesWithOrderBy, 'orderBy', 'desc');
  }

  showCityView(index) {
    this.setState({ currentCityInfo: this.state.cities[index] });
  }

  hideCityView(e) {
    e.preventDefault();
    this.setState({ currentCityInfo: null });
  }

  override render() {
    return (
      <article className="responsive-grid freelance-impact-package">
        <div className="row">
          <header>
            <h1>{getText('page_title')}</h1>
            <p>
              {getText('page_text_part_1')}
              <a href="https://us.illuminas.com/" target="_blank" rel="noreferrer">
                {getText('page_text_link_text')}
              </a>
              {getText('page_text_part_2')}
              <br></br>
              <br></br>
              {getText('page_text_part_3')}
            </p>
          </header>
          <section
            className={`freelance-impact accent-${this.state.accentColor}${
              this.state.currentCityInfo ? ' city-view-visible' : ''
            }`}
          >
            <div className="map-view">
              <SortingTabs
                specialitySorting={this.state.sorting.speciality}
                activeSorting={this.state.activeSorting}
                sortingChangeHandler={this.sortingChangeHandler}
              />
              <SortingDropdowns
                specialitySorting={this.state.sorting.speciality}
                activeSorting={this.state.activeSorting}
                sortingChangeHandler={this.sortingChangeHandler}
              />
              <RankingList
                cities={this.state.cities}
                categorySorting={this.state.sorting.category}
                activeSorting={this.state.activeSorting}
                sortingChangeHandler={this.sortingChangeHandler}
                showCityView={this.showCityView}
              />
              <Map cities={this.state.cities} showCityView={this.showCityView} />
            </div>
            <div className="city-view">
              <div className="back">
                <a href="#" onClick={this.hideCityView}>
                  <i className="fa fa-chevron-left"></i>
                  {getText('back_button')}
                </a>
              </div>
              {this.state.currentCityInfo && (
                <div className="responsive-grid">
                  <div className="row">
                    <CityInfo city={this.state.currentCityInfo} activeYear={this.state.activeYear} />
                    <CityChart dataKey={this.state.activeSorting.category} city={this.state.currentCityInfo} />
                  </div>
                </div>
              )}
            </div>
          </section>
          <Footer />
        </div>
      </article>
    );
  }
}

export default FreelanceImpact;
